var exports = {
  "nd": "SoundboardPanel.module__panel___bDVlY3",
  "Zd": "SoundboardPanel.module__form___bDVlY3",
  "KE": "SoundboardPanel.module__toolbar___bDVlY3",
  "X$": "SoundboardPanel.module__pagination___bDVlY3",
  "o1": "SoundboardPanel.module__actions___bDVlY3",
  "s3": "SoundboardPanel.module__sound___bDVlY3",
  "aK": "SoundboardPanel.module__hint___bDVlY3",
  "Vg": "SoundboardPanel.module__grid___bDVlY3",
  "ZH": "SoundboardPanel.module__play___bDVlY3",
  "UU": "SoundboardPanel.module__name___bDVlY3",
  "pD": "SoundboardPanel.module__volume___bDVlY3",
  "h5": "SoundboardPanel.module__status___bDVlY3",
  "z3": "SoundboardPanel.module__error___bDVlY3",
};

module.exports = exports;
